module.exports = __webpack_public_path__ + "img/dp-top-banner.a89419ab.png";